<template>
    <div class="container-fluid">
        <div>
            <h3>Despesas do mês</h3>
        </div>
        <div class="filters">
            <span class="span-month">Ano:</span>
            <date-picker
                v-model ="year"
                format="YYYY"
                type="year"
                v-on:change="loadYear"
            >
            </date-picker>
        </div>
        <div class="row month-expenses" v-if="expenses.length && updateAll">
            <div class="header-fixed">
                <div class="header fake-table">
                    <div class="name">Nome</div>
                    <div class="replic" title="Replicar a partir do Mês escolhido">Replicar <i class="fas fa-question-circle"></i></div>
                    <div class="month">Janeiro</div>
                    <div class="month">Fevereiro</div>
                    <div class="month">Março</div>
                    <div class="month">Abril</div>
                    <div class="month">Maio</div>
                    <div class="month">Junho</div>
                    <div class="month">Julho</div>
                    <div class="month">Agosto</div>
                    <div class="month">Setembro</div>
                    <div class="month">Outubro</div>
                    <div class="month">Novembro</div>
                    <div class="month">Dezembro</div>
                </div>
                <div class="header-total fake-table" v-if="shouldRefreshTotal">
                    <div class="name">Total</div>
                    <div class="blank-disabled"></div>
                    <div class="expense-data" v-for="index in 12" :key="index">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="total[index]"
                            disabled
                        />
                    </div>
                </div>
            </div>
            <div v-for="expense in expenses" :key="expense.id">
                <div class="fake-table">
                    <div class="name">
                        {{ expense.name }}
                    </div>
                    <div class="expense-date">
                        <date-picker
                            v-model ="importDates[expense.id]"
                            format="MMMM"
                            type="month"
                            v-on:change="importFrom(expense.id, expense.name)"
                        >
                        </date-picker>
                    </div>
                    <div class="expense-content" v-for="index in 12" :key="index">
                        <div class="expense-data" v-if="shouldEdit(expense, index)">
                            <input
                                class="hide-input"
                                v-money="money"
                                v-model.lazy="month_expenses[expense.id][index]"
                                v-on:blur="updateMonthExpenses(expense.id, index)"
                            />
                        </div>
                        <div v-else class="blank-disabled"></div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import DatePicker from 'vue2-datepicker';

    export default {
        name: 'MonthExpenses',
        components: {
            DatePicker
        },
        data () {
            return {
                year: new Date(),
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                expenses: {},
                month_expenses: {},
                updateAll: true,
                shouldRefreshTotal: true,
                total: {},
                importDates: {}
            }
        },
        mounted (){
            this.loadYear()
        },
        methods: {
            formatNumber (number) {
                if (!(number.indexOf('R$') === 0)) {
                    return number
                }
                return number.replace('R$ ', '').replaceAll('.', '').replaceAll(',', '.')
            },
            loadYear () {
                this.clearTotal()
                axios
                    .get('/api/expenses/month?year=' + this.year.getFullYear())
                    .then((response) => {
                        this.expenses = response.data.data
                        for (let index in response.data.data) {
                            let data = response.data.data[index]
                            if (data.deleted_at) {
                                this.expenses[index].deleted_at = new Date(data.deleted_at)
                            }
                            this.month_expenses[data.id] = {}
                            this.$set(this.importDates, data.id, new Date())
                        }
                        axios
                            .get('/api/month_expenses?year=' + this.year.getFullYear())
                            .then((response) => {
                                for (let index in response.data.data) {
                                    let data = response.data.data[index]
                                    this.updateAll = false
                                    this.updateTotal(data)
                                    this.month_expenses[data.expense_id][data.month] = data.value
                                    this.updateAll = true
                                }
                            })
                    })
            },
            parseNumber (number) {
                return parseFloat(this.formatNumber(number))
            },
            updateMonthExpenses (expense_id, month) {
                let data = { 'expense_id': expense_id }
                data.value = this.month_expenses[expense_id][month]
                data.year = this.year.getFullYear()
                data.month = month
                axios.post('/api/month_expenses', data)
                    .then(() => {
                        this.clearTotal()
                        this.recalculateTotal()
                    })
            },
            updateTotal (month_expense) {
                this.shouldRefreshTotal = false
                this.total[month_expense.month] = (this.parseNumber(this.total[month_expense.month]) + this.parseNumber(month_expense.value)).toFixed(2)
                this.shouldRefreshTotal = true
            },
            clearTotal () {
                this.total = {
                    1: '0',
                    2: '0',
                    3: '0',
                    4: '0',
                    5: '0',
                    6: '0',
                    7: '0',
                    8: '0',
                    9: '0',
                    10: '0',
                    11: '0',
                    12: '0'
                }
            },
            recalculateTotal () {
                for (let index in this.month_expenses) {
                    let data = this.month_expenses[index]
                    for (let i in data) {
                        let month_expense = {
                            value: data[i],
                            month: i
                        }
                        this.updateTotal(month_expense)
                    }
                }
            },
            shouldEdit (expense, month) {
                if (expense.deleted_at) {
                    if (expense.deleted_at.getMonth() + 1 < month &&
                        expense.deleted_at.getFullYear() <= this.year.getFullYear()) {
                        return false
                    }
                }

                return true
            },
            importFrom (expense_id, expense_name) {
                let data = {
                    expense_id: expense_id,
                    importFromMonth: this.importDates[expense_id].getMonth() + 1,
                    importFromYear: this.year.getFullYear(),
                }
                this.$confirm(
                    {
                        title: 'Replicar dados da despesa ' + expense_name +
                            ' até o final do ano?',
                        message: `Os dados a partir do mês de `  + this.importDates[expense_id].toLocaleString('pt-BR', { month: 'long' }) +
                            ' serão sobrescritos.',
                        button: {
                            no: 'Não',
                            yes: 'Sim'
                        },
                        callback: confirm => {
                            if (confirm) {
                                axios.post('/api/month_expenses/import', data)
                                    .then(() => {
                                        this.loadYear()
                                    })
                                    .catch(() => {
                                        this.$confirm(
                                            {
                                                title: 'Erro',
                                                message: `Não existe dados cadastrados nesse mês.`,
                                                button: {
                                                    yes: 'OK',
                                                }
                                            }
                                        )
                                    })
                            }
                        }
                    }
                )

            }
        }
    }
</script>

<style scoped lang="sass">
    .span-month
        margin-right: 10px
    .span-import
        margin: 0 10px
    .month-expenses
        font-size: 13px
        margin-top: 20px
        width: 1576px
    .fake-table
        border: 1px solid
        display: inline-block

        .replic
            overflow: hidden
            display: inline-block
            width: 100px
            border-left: 1px solid
            padding: 5px
            margin-bottom: -5px

        .name
            display: inline-block
            width: 250px
            max-width: 250px
            overflow: hidden
            white-space: nowrap
            text-overflow: ellipsis
            padding: 5px
            margin-bottom: -5px

        .expense-content
            display: inline-block

        .expense-data
            overflow: hidden
            display: inline-block
            width: 100px
            border-left: 1px solid
            padding: 5px
            margin-bottom: -5px

        .expense-date
            overflow: hidden
            display: inline-block
            width: 100px
            border-left: 1px solid
            margin-bottom: -3px

        .month
            overflow: hidden
            display: inline-block
            width: 100px
            border-left: 1px solid
            padding: 5px
            margin-bottom: -5px

        .hide-input
            width: 100%

    .header-fixed
        background: white
        position: -webkit-sticky
        position: sticky
        top: 40px
        padding-top: 5px
        z-index: 1

        .blank-disabled
            background: transparent

    .header-total
        background: #bdbdbd7a

        .hide-input:disabled
            color: black !important

    .btn-import
        margin-left: 20px

    .blank-disabled
        display: inline-block
        width: 100px
        height: 29px
        margin-bottom: -4px
        border-left: 1px solid
        background: #bdbdbd7a

    .mx-datepicker
        height: 29px
        width: 100px
</style>
